import script from "./AcceptedRequestItem.vue?vue&type=script&setup=true&lang=js"
export * from "./AcceptedRequestItem.vue?vue&type=script&setup=true&lang=js"

import "./AcceptedRequestItem.vue?vue&type=style&index=0&id=bf4a06ac&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf4a06ac"]])

export default __exports__